module.exports = __webpack_public_path__ + "static/media/stofferingen-35.2dca5ae2.jpg";